import { Apply } from '../../models/apply';
import { ReactiveFormsModule } from '@angular/forms';
import { Component, Input, OnChanges, OnInit, SimpleChanges, Output, EventEmitter, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { MdDialog, MdSelectChange } from '@angular/material';
import { JobsOffer } from '../../models/jobs-offer';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { ItemCandidateComponent } from '../item-candidate/item-candidate.component';
import { Observable } from "rxjs";
import { JobOffersService } from '../../services/job-offers.service';
import { ConfigurationService } from '../../services/configuration.service';
import { Constants } from '../constants';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-view-requisition',
  templateUrl: './view-requisition.component.html',
  styleUrls: ['./view-requisition.component.css']
})

export class ViewRequisition implements OnChanges, OnInit{
  job: JobsOffer;
  create: boolean;
  role: string;
  email: string;
  applicants: Apply;
  @Input() nameComponent;
  question: string;
  errorMessage: string;
  reportDescription: string = null;
  loading: boolean = false;
  public STATUS = Constants;
  public step: number;
  public questionFormGroup: FormGroup;
  emailRegex: any = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  constructor(public dialog: MdDialog,
              public dialogRef: MdDialogRef<ViewRequisition>,
              private jobService: JobOffersService,
              private configurationService: ConfigurationService,
              private fb: FormBuilder,
              @Inject(MD_DIALOG_DATA) public data: any,
              ) {
  }

  ngOnInit () {
    this.questionFormGroup = this.fb.group({
      question: ['', Validators.required],
    });

    this.job = this.data.job;
    this.create = this.data.create;

    this.configurationService.configuration$.subscribe(
      response => {
        if (response) {
          this.role = localStorage.getItem('role');
        }
      }
    );

  }

  openDialogPostFreelancer(job) {
    this.jobService.postOffersAddFreelancer(job.id)
    .subscribe(
      data => {
        this.getJob(job);
        this.dialog.open(MessageBoxDialog, {data: {message: 'Te has postulado a la oferta cómo freelancer, desbes esperar por la confirmación para comenzar a trabajarla', information: true, showIcon: true}});

      },
      error => {
        this.errorMessage = <any>error;
        this.dialog.open(MessageBoxDialog, {data: {message: 'Hubo un error al postularte a la oferta: ' + this.errorMessage, information: true, showIcon: true}});
      }
    );
  }

  getJob(job) {
    this.jobService.getOffersFreelancerById(job.id)
    .subscribe(
      data => {
        this.job = data;

      },
      error => {
        this.errorMessage = <any>error;
        this.dialog.open(MessageBoxDialog, {data: {message: 'Hubo un error al postularte a la oferta: ' + this.errorMessage, information: true, showIcon: true}});
      }
    );
  }

  onPostQuestion(job) {
    console.log(this.question);
    this.jobService.postQuestionJob(job.id, this.question)
    .subscribe(
      data => {
        this.getJob(job);
        this.dialog.open(MessageBoxDialog, {data: {message: 'Su pregunta "' + this.question + '" ha sido enviada a nuestro Staff para ser respondida', information: true, showIcon: true}});
        this.questionFormGroup.reset();
      },
      error => {
        this.errorMessage = <any>error;
        this.dialog.open(MessageBoxDialog, {data: {message: 'Hubo un error al realizar la pregunta: ' + this.errorMessage, information: true, showIcon: true}});
      }
    );
  }


  ngOnChanges(changes: SimpleChanges) {
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/view-requisition/view-requisition.component.ts